import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { withHandlers } from '../../../../node_module_clones/recompose';

import { connect } from 'react-redux';

import FileInput from './FileInput';
import fileDropTargetDecorator from './fileDropTargetDecorator';

import iterateOverPromises from '../../../../common/utils/lib/iterateOverPromises';
import { createElementAsync } from '../../../element/actions/elementActions';

import { isFileCompatibleWithImageElement } from '../../../../common/files/fileValidator';
import { showFileInDetailView } from '../../../../common/files/filePreviewUtils';

// Constants
import { ELEMENT_DISPLAY_MODES } from '../../../../common/elements/elementDisplayModeConstants';
import { ElementType } from '../../../../common/elements/elementTypes';

const mapDispatchToProps = (dispatch) => ({
    dispatchCreateElement: (args) => dispatch(createElementAsync(args)),
});

@connect(null, mapDispatchToProps)
@withHandlers({
    uploadMultipleFiles: (props) => (files, transactionId) => {
        const { dispatchCreateElement, getElementLocation, creationSource, uploadCallbackFn } = props;

        uploadCallbackFn && uploadCallbackFn();

        return iterateOverPromises((file) => {
            const elementType = isFileCompatibleWithImageElement(file) ? ElementType.IMAGE_TYPE : ElementType.FILE_TYPE;

            let displayMode;
            if (elementType === ElementType.FILE_TYPE) {
                displayMode = showFileInDetailView(file)
                    ? ELEMENT_DISPLAY_MODES.DETAIL_VIEW
                    : ELEMENT_DISPLAY_MODES.ICON_VIEW;
            }

            return dispatchCreateElement({
                elementType,
                location: getElementLocation(props),
                attachment: file,
                creationSource,
                content: {
                    displayMode,
                },
                transactionId,
            });
        }, files);
    },
})
@fileDropTargetDecorator
class FileUploadForm extends React.Component {
    openFileSelect = (event) => {
        const fileInputDomNode = ReactDOM.findDOMNode(this.fileInput);
        fileInputDomNode && fileInputDomNode.click();
    };

    render() {
        const { fileIsHovered, connectFileDropTarget, className, children, accept } = this.props;

        return connectFileDropTarget(
            <div className={classNames('FileUploadForm', className, { hovered: fileIsHovered })}>
                <FileInput
                    ref={(c) => {
                        this.fileInput = c;
                    }}
                    {...this.props}
                    id="new"
                    accept={accept || '*'}
                    multiple
                />

                {children(this.openFileSelect)}
            </div>,
        );
    }
}

FileUploadForm.propTypes = {
    className: PropTypes.string,
    currentBoardId: PropTypes.string,
    accept: PropTypes.string,
    fileIsHovered: PropTypes.bool,
    dispatchCreateElement: PropTypes.func,
    uploadCallbackFn: PropTypes.func,
    uploadFile: PropTypes.func,
    connectFileDropTarget: PropTypes.func,
    onUploadFile: PropTypes.func,
    children: PropTypes.func,
};

export default FileUploadForm;
